import { atom } from "jotai";
import { KOREAN } from "../constants/language";

export const languageModeAtom = atom(KOREAN);
